import moment from "moment"
import { Filters } from "../../common/data/definitions"

const FORMATO_INICIO = "YYYY-MM-DD 00:00:00"
const FORMATO_FIM = "YYYY-MM-DD 23:59:59"

const cobreMesesInteiros = (inicio, fim) =>
  inicio.date() === 1 && fim.isSame(fim.clone().endOf("month"), "day")

/**
 * Período de comparação dos cards "do período anterior". Mês inteiro compara com os meses
 * inteiros imediatamente antes (setembro contra agosto, mesmo com outro número de dias);
 * qualquer outro intervalo compara com o mesmo número de dias logo antes do início.
 */
export const periodoAnterior = (inicioPeriodo, fimPeriodo) => {
  if (!inicioPeriodo || !fimPeriodo) return null

  const inicio = moment(inicioPeriodo).startOf("day")
  const fim = moment(fimPeriodo).startOf("day")

  if (cobreMesesInteiros(inicio, fim)) {
    const meses = fim.diff(inicio, "months") + 1
    const inicioAnterior = inicio.clone().subtract(meses, "months")
    return {
      inicio: inicioAnterior.format(FORMATO_INICIO),
      fim: inicio.clone().subtract(1, "day").format(FORMATO_FIM)
    }
  }

  const dias = fim.diff(inicio, "days") + 1
  return {
    inicio: inicio.clone().subtract(dias, "days").format(FORMATO_INICIO),
    fim: inicio.clone().subtract(1, "day").format(FORMATO_FIM)
  }
}

/**
 * Os cards somam as mesmas vendas da grade: todos os filtros da tela valem, só o período
 * pode ser trocado (para o comparativo com o período anterior).
 */
export const filtrosDoPeriodo = (filtros, periodo) => [
  ...(filtros || []).filter(filtro => filtro.id !== "Data"),
  { id: "Data", value: periodo.inicio, condition: Filters.greaterThanOrEqualTo },
  { id: "Data", value: periodo.fim, condition: Filters.lessThanOrEqualTo }
]

// Valor_Total do totalizador já inclui taxa de serviço e de entrega, como o total da grade.
export const PROJECAO_TOTALIZADOR = ["Valor_Total", ["1", "Qtd_Vendas"]]

/** Ticket médio por atendimento, como no Dashboard: valor vendido ÷ quantidade de vendas. */
export const resumirTotalizador = resultado => {
  const linha = (resultado?.data || [])[0] || {}
  const vendas = Number(linha.Valor_Total) || 0
  const quantidade = Number(linha.Qtd_Vendas) || 0

  return { vendas, quantidade, ticket: quantidade > 0 ? vendas / quantidade : 0 }
}
